import moment from 'moment';
import React, { useEffect, useRef } from 'react';
import useCountDown from 'utils/hooks/useCountDown';
import { parseSecondsToMinutesAndHours } from 'utils/time';
interface ICountdownProps {
  onTimeout?: () => void;
  orderCheckout?: any;
}
const Countdown = ({ onTimeout, orderCheckout }: ICountdownProps) => {
  const isTimeout = useRef(false);
  const expiredAt = moment(
    orderCheckout?.expireAt ?? undefined,
    'HH:mm:ss DD/MM/YYYY',
  );
  const startTime = moment(
    orderCheckout?.createdAt ?? undefined,
    'HH:mm:ss DD/MM/YYYY',
  );
  const time = expiredAt.valueOf() - startTime.valueOf();
  const { timeRemaining } = useCountDown({
    time,
    interval: 1000,
    startTime: startTime.valueOf(),
  });
  const { minutes, seconds, hours } = parseSecondsToMinutesAndHours(
    timeRemaining / 1000,
  );
  useEffect(() => {
    if (timeRemaining <= 0 && !isTimeout.current) {
      onTimeout && onTimeout();
      isTimeout.current = true;
    }
  }, [timeRemaining, onTimeout]);
  useEffect(() => {
    return () => {
      isTimeout.current = true;
    };
  }, []);
  return (
    <span style={{ color: '#E92127' }}>{`${hours < 10 ? '0' : ''}${hours}:${
      minutes < 10 ? '0' : ''
    }${minutes}:${seconds < 10 ? '0' : ''}${seconds}`}</span>
  );
};
export default Countdown;
